export default "__VITE_ASSET__CcPEn4VD__"